// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav-module--nav--2KxLB"};